import { ensureGtag } from "./gtag";

const LABEL = /^[A-Za-z0-9_-]{4,40}$/;
const configured = new Set();

// Google Ads only takes conversions: Lead (when the affiliate set a lead label) and Purchase.
const labelFor = (event, labels) => {
  if (!labels) return null;
  if (event === "Purchase") return labels.purchase;
  if (event === "Lead") return labels.lead;
  return null;
};

const googleAds = {
  isValid: (pixel) =>
    /^AW-\d{6,12}$/.test(pixel.id) &&
    !!pixel.labels &&
    LABEL.test(pixel.labels.purchase || "") &&
    (!pixel.labels.lead || LABEL.test(pixel.labels.lead)),

  load(pixels) {
    ensureGtag(pixels[0].id);
    pixels.forEach(({ id }) => {
      if (configured.has(id)) return;
      configured.add(id);
      window.gtag("config", id, { groups: "affiliate" });
    });
  },

  send(event, data, key, pixel) {
    const label = labelFor(event, pixel.labels);
    if (!label) return;
    const params = { send_to: `${pixel.id}/${label}` };
    if (data.value != null) {
      params.value = data.value;
      params.currency = data.currency;
    }
    if (key) params.transaction_id = key;
    window.gtag("event", "conversion", params);
  },
};

export default googleAds;
